// ============================================================
// Yeniden çizim köprüsü
//
// Görünümler ve olay bağlayıcıları ekranı tazelemek ister ama
// app-shell'i içe aktaramaz — o zaten onları içe aktarıyor.
// Kabuk açılışta gerçek render fonksiyonunu buraya kaydeder,
// diğer modüller yalnızca rerender() çağırır. Döngüsel bağımlılık
// böylece tek yönlü bir kayıt hâline gelir.
// ============================================================

let cizim = () => {};

export const onRerender = fn => { cizim = fn; };
export const rerender = () => cizim();
